import { QrCode } from 'lucide-react';

interface Props {
  qrPayload?: string | null;
  verifyUrl?: string | null;
  size?: 'sm' | 'md' | 'lg';
}

const BOX: Record<string, number> = { sm: 52, md: 64, lg: 80 };
const ICON_SIZES = { sm: 'w-7 h-7', md: 'w-9 h-9', lg: 'w-12 h-12' };

export default function DocumentQRCodeBlock({ qrPayload, size = 'md' }: Props) {
  const px = BOX[size] ?? 64;
  return (
    <div className="flex flex-col items-center gap-0.5 shrink-0 a4-keep-together">
      <div className="border-2 border-gray-800 rounded flex items-center justify-center bg-white"
        style={{ width: `${px}px`, height: `${px}px` }}>
        {qrPayload ? (
          <div className="relative w-full h-full flex items-center justify-center">
            <QrCode className={`${ICON_SIZES[size]} text-gray-800`} />
            <div className="absolute bottom-0.5 right-0.5 w-1.5 h-1.5 bg-teal-600 rounded-sm" />
          </div>
        ) : (
          <QrCode className={`${ICON_SIZES[size]} text-gray-300`} />
        )}
      </div>
      <p className="text-[6px] text-gray-500 text-center font-medium leading-tight">
        Scan to verify<br />on NeoVerify
      </p>
    </div>
  );
}
